import {
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Col,
    Label
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState, useEffect } from "react"
import { httpRequest } from "utils/httpRequest";
import TextEditor from "components/editor/TextEditor";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"
import { useRef } from "react";

const AddSRB = () => {
    const [imagePreview, setImagePreview] = useState(null);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [stateCityData, setStateCityData] = useState([]);
    const [cities, setCities] = useState([]);

    const navigate = useNavigate()
    const prevSelectedState = useRef("");

    // Form validation schema using Yup
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        state: Yup.string().required("State is required"),
        city: Yup.string().required("City is required"),
        description: Yup.string().required("Description is required"),
        image: Yup.mixed().required("Image is required"),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            state: "",
            city: "",
            description: "",
            image: null,
        },
        validationSchema,
        onSubmit: async (values) => {

            formik.setTouched({

                name: true,
                state: true,
                city: true,
                description: "",
                image: ""
            });

            const errors = await formik.validateForm();

            if (Object.keys(errors).length > 0) return false;
            setButtonLoading(true)
            try {
                const uploadedImageLink = await getUploadedImageLink(values.image);

                const response = await httpRequest(
                    "associate/add",
                    "POST",
                    {
                        name: values?.name,
                        state: values?.state,
                        city: values?.city,
                        description: values?.description,
                        image: uploadedImageLink
                    },
                    {},
                    true,
                    true
                );
                if (response?.code === 200) {

                    toast.success("Associate srb Created Successfully")
                    formik.resetForm({
                        values: {
                            name: "",
                            state: "",
                            city: "",
                            description: "",
                            image: null,
                        }
                    })
                    navigate("/admin/associate-srb")



                }

            } catch (error) {
                console.log(error);
                toast.error(error?.message || "Somethin went wrong")
            } finally {
                setButtonLoading(false)
            }
        },
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Create a temporary URL for the uploaded image
            const imageUrl = URL.createObjectURL(file);
            setImagePreview(imageUrl);
            formik.setFieldValue("image", file);
        }
    };


    const getUploadedImageLink = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await httpRequest(
                "admin/UploadMedia",
                "POST",
                formData,
                {},
                true,
                true
            );
            return response?.filePath;
        } catch (error) {
            console.log("Upload error:", error);
            throw error;
        }
    };

    useEffect(() => {
        fetchStateAndCityList()
    }, [])

    useEffect(() => {
        const selected = stateCityData.find(
            (s) => s.name.toLowerCase() === formik.values.state.toLowerCase()
        );

        if (selected) {
            setCities(selected.cities);
        } else {
            setCities([]);
        }

        // Only reset city if state value actually changed
        if (prevSelectedState.current !== formik.values.state) {
            formik.setFieldValue("city", "");
            prevSelectedState.current = formik.values.state;
        }
    }, [formik.values.state, stateCityData]);


    const fetchStateAndCityList = async () => {
        try {
            const response = await httpRequest(
                "video/state-city-list",
                "GET",
                {},
                {},
                true,
                false
            );
            console.log("ree", response)
            setStateCityData(response);
        } catch (error) {
            console.log(error)
        }


    }




    return (
        <Col lg="8" md="8" className="mx-auto mt-4">
            <Card className="bg-secondary shadow border-0">
                <CardHeader className="bg-transparent pb-3">
                    <div className="text-muted text-center mt-2 mb-3">
                        <small>Add Content SRB </small>
                    </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-4">
                    <Form onSubmit={formik.handleSubmit}>
                        {/* Name */}
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-single-02" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Name"
                                    type="text"
                                    name="name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.name && formik.errors.name ? true : false}
                                    disabled={formik.isSubmitting}
                                />
                            </InputGroup>
                            {formik.touched.name && formik.errors.name ? (
                                <div className="text-danger small mt-1">{formik.errors.name}</div>
                            ) : null}
                        </FormGroup>

                        {/* State */}
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-world" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    type="select"
                                    name="state"
                                    value={formik.values.state}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.state && !!formik.errors.state}
                                    disabled={formik.isSubmitting}
                                >
                                    <option value="">Select State</option>
                                    {stateCityData?.map((state) => (
                                        <option key={state.name} value={state.name}>
                                            {state.name}
                                        </option>
                                    ))}
                                </Input>
                            </InputGroup>
                            {formik.touched.state && formik.errors.state && (
                                <div className="text-danger small mt-1">{formik.errors.state}</div>
                            )}
                        </FormGroup>

                        {/* City */}
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-pin-3" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    type="select"
                                    name="city"
                                    value={formik.values.city}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.city && !!formik.errors.city}
                                    disabled={cities.length === 0 || formik.isSubmitting}
                                >
                                    <option value="">Select City</option>
                                    {cities.map((city) => (
                                        <option key={city._id} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))}
                                </Input>
                            </InputGroup>
                            {formik.touched.city && formik.errors.city && (
                                <div className="text-danger small mt-1">{formik.errors.city}</div>
                            )}
                        </FormGroup>

                        {/* Description */}
                        {/* <FormGroup>
                            <label className="form-control-label">Description</label>
                            <Input
                                type="textarea"
                                name="description"
                                rows="6"
                                placeholder="Write the description..."
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={formik.touched.description && formik.errors.description ? true : false}
                            />
                            {formik.touched.description && formik.errors.description ? (
                                <div className="text-danger small mt-1">{formik.errors.description}</div>
                            ) : null}
                        </FormGroup> */}
                        <FormGroup>
                            <Label className="form-control-label">Article Description</Label>
                            <TextEditor
                                value={formik.values.description}
                                onChange={(html) => formik.setFieldValue("description", html)}
                                onBlur={() => formik.setFieldTouched("description", true)}
                                placeholder="Write the article description..."
                                hideImageAndLink={false}
                            />
                            {formik.touched.description && formik.errors.description && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.description}
                                </div>
                            )}
                        </FormGroup>

                        {/* Image Upload */}
                        <FormGroup>
                            <label className="form-control-label">Upload Image</label>
                            <Input
                                type="file"
                                name="image"
                                onChange={handleImageChange}
                                accept="image/*"
                                onBlur={formik.handleBlur}
                                invalid={formik.touched.image && formik.errors.image ? true : false}
                                disabled={formik.isSubmitting}
                            />
                            {formik.touched.image && formik.errors.image ? (
                                <div className="text-danger small mt-1">{formik.errors.image}</div>
                            ) : null}
                        </FormGroup>

                        {imagePreview && (
                            <div className="mt-3">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ maxWidth: "25%", height: "auto", borderRadius: "0.25rem" }}
                                />
                            </div>
                        )}

                        <div className="text-center d-flex align-items-center justify-content-center">
                            <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                                {buttonLoading ? <span className="button-loader"></span> : "Submit"}
                            </Button>

                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default AddSRB;